import { useCompanyApi } from '@lendica/hooks';

export const useReportsApi = () => {
    const api = useCompanyApi();
    return {
        getAccountSummary: () => api.get('/reporting/download_approval_summary'),
        getDealSummary: () => api.get('/reporting/download_deal_summary'),
        getTransactionSummary: () => api.get('/reporting/download_transaction_summary'),
        getFuturePayments: () => api.get('/reporting/download_30_day_payment'),
    };
};
